/* 🤖 this file was generated by svg-to-ts */
export const siriusUserCircle: {
  name: 'user_circle';
  data: string;
} = {
  name: 'user_circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.56 19.213A9.725 9.725 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.725 9.725 0 0 0 3.27 7.286A9.713 9.713 0 0 0 12 21.75a9.714 9.714 0 0 0 6.56-2.537ZM12 3.75a8.25 8.25 0 0 0-6.167 13.73 7.5 7.5 0 0 1 3.383-2.695 4.5 4.5 0 1 1 5.569 0 7.512 7.512 0 0 1 3.382 2.696A8.25 8.25 0 0 0 12 3.75Zm5.056 14.77a6 6 0 0 0-10.112 0A8.215 8.215 0 0 0 12 20.25c1.905 0 3.66-.646 5.056-1.73Zm-5.005-4.27a3 3 0 1 0-.103 0h.104Z" fill="currentColor"/></svg>`
};
